import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-question-mark-circle-icon',
  templateUrl: 'question-mark-circle-icon.component.html'
})
export class QuestionMarkCircleIconComponent {
  constructor() {}
}
